import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';

@Injectable({
  providedIn: 'root'
})
export class ActivateService implements CanActivate {
  constructor(public router: Router) {}
  
  canActivate(): boolean {
    // First check if user is authenticated
    const accessToken = localStorage.getItem('accessToken');
    const userId = localStorage.getItem('userId');

    console.log('🔑 ActivateService.canActivate:', {
      hasToken: !!accessToken,
      hasUserId: !!userId
    });

    if (!accessToken || !userId) {
      console.log('❌ ActivateService: User not authenticated, redirecting to login');
      this.router.navigate(['/login']);
      return false;
    }

    // Then check dashboard activation status
    const dashboardActive = localStorage.getItem('dashboardActive');

    // dashboardActive='0'（スタッフ）も'1'（管理者）もアクセス許可
    // パスワード変更画面へのリダイレクトを削除
    // スタッフユーザーも通常通りダッシュボードアクセス可能

    console.log('✅ ActivateService: Access granted');
    return true;
  }
}

@Injectable({
  providedIn: 'root'
})
export class AuthGuardService implements CanActivate {
  constructor(private router: Router) {}

  canActivate(): boolean {
    const isAuthenticated = this.isLoggedIn();

    console.log('🔒 AuthGuardService.canActivate:', {
      isAuthenticated,
      hasToken: !!localStorage.getItem('accessToken'),
      hasUserId: !!localStorage.getItem('userId')
    });

    if (!isAuthenticated) {
      console.log('❌ User not authenticated, redirecting to login');
      this.router.navigate(['/login']);
      return false;
    }

    console.log('✅ User authenticated, allowing access');
    return true;
  }

  private isLoggedIn(): boolean {
    const accessToken = localStorage.getItem('accessToken');
    const userId = localStorage.getItem('userId');
    const dashboardActive = localStorage.getItem('dashboardActive');

    console.log('🔐 isLoggedIn check:', {
      hasAccessToken: !!accessToken,
      hasUserId: !!userId,
      dashboardActive
    });

    // 基本的な認証情報の確認（accessTokenとuserIdのみ）
    if (!accessToken || !userId) {
      console.log('❌ Missing accessToken or userId');
      return false;
    }

    // dashboardActive='0'（スタッフユーザー）も認証OK
    // '0'=スタッフ、'1'=管理者の両方がログイン可能

    // Check if token is expired (basic check)
    try {
      const tokenPayload = JSON.parse(atob(accessToken.split('.')[1]));
      const currentTime = Math.floor(Date.now() / 1000);

      console.log('🔐 Token validation:', {
        exp: tokenPayload.exp,
        currentTime,
        isExpired: tokenPayload.exp < currentTime
      });

      if (tokenPayload.exp && tokenPayload.exp < currentTime) {
        console.log('❌ Token expired, clearing auth data');
        this.clearAuthData();
        return false;
      }
    } catch (error) {
      console.log('❌ Invalid token format, clearing auth data:', error);
      this.clearAuthData();
      return false;
    }

    console.log('✅ isLoggedIn: true');
    return true;
  }

  private clearAuthData(): void {
    localStorage.removeItem('accessToken');
    localStorage.removeItem('userId');
    localStorage.removeItem('userRole');
    localStorage.removeItem('dashboardActive');
  }

  public logout(): void {
    this.clearAuthData();
    this.router.navigate(['/login']);
  }

  public isAuthenticated(): boolean {
    return this.isLoggedIn();
  }

  public getToken(): string | null {
    return localStorage.getItem('accessToken');
  }

  public getUserId(): string | null {
    return localStorage.getItem('userId');
  }

  public getUserRole(): string | null {
    return localStorage.getItem('userRole');
  }
}
